module.exports = __webpack_public_path__ + "static/media/siddharth-vidhana-soudha-trip-banner.d18a6ad5.jpg";